import Swal from 'sweetalert2'

globalThis.Swal = Swal
